var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVehicleWheelIcon = function SvgVehicleWheelIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M9 10.055A.527.527 0 1 0 9 9a.527.527 0 0 0 0 1.055"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9 0C4.044 0 0 4.045 0 9c0 4.956 4.045 9 9 9 4.956 0 9-4.045 9-9 0-4.956-4.045-9-9-9m0 2.145c3.422 0 6.265 2.52 6.774 5.8h-1.828c-1.16 0-2.262-.465-3.023-1.276a2.64 2.64 0 0 0-3.846 0c-.761.811-1.863 1.276-3.023 1.276H2.226c.508-3.28 3.352-5.8 6.774-5.8m0 8.964c-.872 0-1.582-.71-1.582-1.582S8.128 7.945 9 7.945s1.582.71 1.582 1.582S9.872 11.11 9 11.11m-6.384.39c.604-.236 1.04-.39 1.638-.39a3.167 3.167 0 0 1 3.128 3.639h-.001a3.2 3.2 0 0 1-.25.849A6.89 6.89 0 0 1 2.616 11.5m8.253 4.097a3.1 3.1 0 0 1-.25-.848h-.001c-.338-2.243 1.733-4.094 3.88-3.549.226.058.509.153.886.3a6.89 6.89 0 0 1-4.515 4.097"
  })));
};
export default SvgVehicleWheelIcon;